export const errorsMessage = {
  required: "required",
  invalid_format: "invalid_format",
  email: "invalid_email_error",
  invalid_date: "invalid_date",
  image_max_size: "image_max_size",
  no_past_date: "no_past_date",
  required_count_security_questions: "required_count_security_questions",
  min_8_characters: "min_8_length",
  lowercase_required: "lowercase_required",
  uppercase_required: "uppercase_required",
  number_required: "number_required",
  special_character: "special_character_required",
};
